import { render, staticRenderFns } from "./CustomRolesAdmin.vue?vue&type=template&id=75797f7b&"
import script from "./CustomRolesAdmin.vue?vue&type=script&lang=js&"
export * from "./CustomRolesAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports